module.exports = __webpack_public_path__ + "static/img/Zak-Johnson.c87c962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zak-Johnson.jpg
// module id = gO7a
// module chunks = 0